import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import './CollecteTwin.css'; // Feuille CSS pour styles
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AddChargeExp, getchargexp } from '../Redux/Actions/ChargeExpActions';
import { current } from "../Redux/Actions/AuthActions";
import axios from 'axios';

const ChargeExp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(current());
    dispatch(getchargexp());
  }, [dispatch]);

  const user = useSelector((state) => state.AuthReducer.user);
  const chargeExpl = useSelector((state) => state.ChargeExpReducer.ChargeExpl);

  const [customCategories, setCustomCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryRbe, setNewCategoryRbe] = useState('');
  const [editingCategory, setEditingCategory] = useState(null);

  const fetchCategories = () => {
    axios.get('/api/ChargeExp/GetChargeCategories')
      .then(res => {
        setCustomCategories(res.data.categories || []);
      })
      .catch(err => console.error("Error fetching categories:", err));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const uniqueObjets = React.useMemo(() => {
    const defaultObjets = [
      "Loyers", "Paiement des Crédits", "Agios", "Déclaration fiscales", "Echéancier Fiscal",
      "Les salaires", "STEG", "SONEDE", "CNSS", "Assurance", "entretien voiture", "Carburant",
      "Opérateurs téléphoniques", "Opérateur Internet", "Fournitures de Bureau", "Achat jouets",
      "Achats Candybar"
    ];
    const cleanCategories = customCategories.map(c => c.name);
    const cleanChargeExpl = chargeExpl || [];
    const dbObjets = cleanChargeExpl.map(item => item.objet).filter(Boolean);
    const combined = new Set([...defaultObjets, ...cleanCategories, ...dbObjets]);
    return Array.from(combined);
  }, [chargeExpl, customCategories]);

  const handleCategorySubmit = (e) => {
    e.preventDefault();
    if (!newCategoryName.trim() || !newCategoryRbe) return;

    const token = localStorage.getItem('token');
    const headers = { Authorised: token };

    if (editingCategory) {
      axios.put(`/api/ChargeExp/UpdateChargeCategory/${editingCategory._id}`, {
        name: newCategoryName.trim(),
        rbeCategory: newCategoryRbe
      }, { headers })
      .then(res => {
        alert("Catégorie de charge modifiée avec succès !");
        setNewCategoryName('');
        setNewCategoryRbe('');
        setEditingCategory(null);
        fetchCategories();
      })
      .catch(err => {
        console.error(err);
        alert(err.response?.data?.msg || "Erreur lors de la modification de la catégorie.");
      });
    } else {
      axios.post('/api/ChargeExp/AddChargeCategory', {
        name: newCategoryName.trim(),
        rbeCategory: newCategoryRbe
      }, { headers })
      .then(res => {
        alert("Catégorie de charge ajoutée avec succès !");
        setNewCategoryName('');
        setNewCategoryRbe('');
        fetchCategories();
      })
      .catch(err => {
        console.error(err);
        alert(err.response?.data?.msg || "Erreur lors de la création de la catégorie.");
      });
    }
  };

  const handleEditCategory = (cat) => {
    setEditingCategory(cat);
    setNewCategoryName(cat.name);
    setNewCategoryRbe(cat.rbeCategory);
  };

  const handleCancelEditCategory = () => {
    setEditingCategory(null);
    setNewCategoryName('');
    setNewCategoryRbe('');
  };

  const handleDeleteCategory = (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette catégorie de charge ? Elle sera retirée de la bande déroulante.")) {
      const token = localStorage.getItem('token');
      axios.delete(`/api/ChargeExp/DeleteChargeCategory/${id}`, {
        headers: {
          Authorised: token
        }
      })
      .then(res => {
        alert("Catégorie supprimée avec succès !");
        fetchCategories();
        if (editingCategory && editingCategory._id === id) {
          handleCancelEditCategory();
        }
      })
      .catch(err => {
        console.error(err);
        alert(err.response?.data?.msg || "Erreur lors de la suppression de la catégorie.");
      });
    }
  };

  const [emplacement, setEmplacement] = useState('');
  const [objet, setObjet] = useState('');
  const [customObjet, setCustomObjet] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [amount, setAmount] = useState('');
  const [expense, setExpense] = useState('');
  const [explanation, setExplanation] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  // Définir l'emplacement par défaut basé sur la localisation de l'utilisateur
  useEffect(() => {
    if (user && !emplacement) {
      if (user.localisation) {
        setEmplacement(user.localisation);
      }
    }
  }, [user, emplacement]);

  const handleRapport = (e) => {
    e.preventDefault();

    // Validation des champs
    if (!emplacement || emplacement === "Choisissez un emplacement...") {
      alert("Veuillez choisir un emplacement.");
      return;
    }
    if (!objet || objet === "Types de Charges...") {
      alert("Veuillez choisir l'objet de la charge.");
      return;
    }
    if (objet === "Autre" && !customObjet.trim()) {
      alert("Veuillez saisir le nom de la nouvelle charge.");
      return;
    }
    if (!date) {
      alert("Veuillez saisir une date valide.");
      return;
    }
    if (!amount || parseFloat(amount) <= 0) {
      alert("Veuillez saisir un montant supérieur à 0.");
      return;
    }
    if (!explanation) {
      alert("Veuillez donner une explication.");
      return;
    }
    if (!confirmed) {
      alert("Veuillez cocher la case pour confirmer vos données.");
      return;
    }

    const finalObjet = objet === "Autre" ? customObjet.trim() : objet;

    const isStandard = [
      "Loyers", "Paiement des Crédits", "Agios", "Déclaration fiscales", "Echéancier Fiscal",
      "Les salaires", "STEG", "SONEDE", "CNSS", "Assurance", "entretien voiture", "Carburant",
      "Opérateurs téléphoniques", "Opérateur Internet", "Fournitures de Bureau", "Achat jouets",
      "Achats Candybar"
    ].includes(finalObjet);

    // Données à envoyer
    const rapportData = {
      DateCollect: date.slice(0, 10),
      localisation: emplacement,
      objet: finalObjet,
      TotalAmount: parseFloat(amount),
      DailyExpenses: parseFloat(expense || 0),
      feedback: explanation,

      Loyers: finalObjet === "Loyers" ? parseFloat(amount) : 0,
      Banques: (finalObjet === "Paiement des Crédits" || finalObjet === "Agios") ? parseFloat(amount) : 0,
      Fisc: (finalObjet === "Déclaration fiscales" || finalObjet === "Echéancier Fiscal") ? parseFloat(amount) : 0,
      Salaire: finalObjet === "Les salaires" ? parseFloat(amount) : 0,
      Steg: finalObjet === "STEG" ? parseFloat(amount) : 0,
      Sonede: finalObjet === "SONEDE" ? parseFloat(amount) : 0,
      Cnss: finalObjet === "CNSS" ? parseFloat(amount) : 0,
      Assurance: finalObjet === "Assurance" ? parseFloat(amount) : 0,
      Entretien: finalObjet === "entretien voiture" ? parseFloat(amount) : 0,
      Carburant: finalObjet === "Carburant" ? parseFloat(amount) : 0,
      OperateurTel: finalObjet === "Opérateurs téléphoniques" ? parseFloat(amount) : 0,
      OperateurFibre: finalObjet === "Opérateur Internet" ? parseFloat(amount) : 0,
      FournituresBureau: finalObjet === "Fournitures de Bureau" ? parseFloat(amount) : 0,
      AchatsToys: finalObjet === "Achat jouets" ? parseFloat(amount) : 0,
      AchatsCandyBar: finalObjet === "Achats Candybar" ? parseFloat(amount) : 0,
      DeclarationFiscales: finalObjet === "Déclaration fiscales" ? parseFloat(amount) : 0,
      EcheancierFiscal: finalObjet === "Echéancier Fiscal" ? parseFloat(amount) : 0,
      PaiementCredits: finalObjet === "Paiement des Crédits" ? parseFloat(amount) : 0,
      Agios: finalObjet === "Agios" ? parseFloat(amount) : 0,
      Autres: !isStandard ? parseFloat(amount) : 0,
    };

    dispatch(AddChargeExp(rapportData)).then((success) => {
      if (success) {
        setObjet('');
        setCustomObjet('');
        setAmount('');
        setExpense('');
        setExplanation('');
        setConfirmed(false);
      }
    });
  };

  return (
    <div className="list-rapports">
      <h3>Saisie des Charges d'Exploitation</h3>

      <Row>
        <Col md={user?.role === 'admin' ? 8 : 12}>
          <Form className="rapport-form" onSubmit={handleRapport}>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridState" className="rapport-form-group">
            <Form.Label>Emplacement</Form.Label>
            <Form.Select
              onChange={(e) => setEmplacement(e.target.value)}
              className="rapport-select"
              value={emplacement || "Choisissez un emplacement..."}
            >
              <option disabled value="Choisissez un emplacement...">Choisissez un emplacement...</option>
              <option>Manar City</option>
              <option>Tunisia Mall</option>
              <option>Jardins d'El Menzah</option>
              <option>Jump Zone</option>
              <option>Entourage</option>
              <option>Art & Craft</option>
              <option>Administration</option>
            </Form.Select>
          </Form.Group>

          <Form.Group as={Col} controlId="formGridObjet" className="rapport-form-group">
            <Form.Label>Objet de la Charge</Form.Label>
            <Form.Select
              onChange={(e) => setObjet(e.target.value)}
              className="rapport-select"
              value={objet || "Types de Charges..."}
            >
              <option disabled value="Types de Charges...">Types de Charges...</option>
              {uniqueObjets.map((obj, idx) => (
                <option key={idx} value={obj}>{obj}</option>
              ))}
              <option value="Autre">Autre (Saisir...)</option>
            </Form.Select>
          </Form.Group>
        </Row>

        {objet === 'Autre' && (
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridCustomObjet" className="rapport-form-group">
              <Form.Label>Nom de la nouvelle charge</Form.Label>
              <Form.Control
                type="text"
                className="rapport-input"
                value={customObjet}
                onChange={(e) => setCustomObjet(e.target.value)}
                placeholder="Ex: Nettoyage, Maintenance, Publicité..."
                required
              />
            </Form.Group>
          </Row>
        )}

        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridDate" className="rapport-form-group">
            <Form.Label>Date de la Charge</Form.Label>
            <Form.Control
              type="date"
              className="rapport-input"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              readOnly={user?.role !== 'admin'} // Seul l'admin peut modifier la date
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridAmount" className="rapport-form-group">
            <Form.Label>Montant de la Charge (TND)</Form.Label>
            <Form.Control
              onChange={(e) => setAmount(e.target.value)}
              type="number"
              step="0.001"
              value={amount}
              className="rapport-input"
              placeholder="Ex: 250.000"
              min="0"
            />
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridExpenses" className="rapport-form-group">
            <Form.Label>Dépenses Opérationnelles associées (Optionnel)</Form.Label>
            <Form.Control
              onChange={(e) => setExpense(e.target.value)}
              type="number"
              step="0.001"
              value={expense}
              className="rapport-input"
              placeholder="Ex: 15.500"
              min="0"
            />
          </Form.Group>
        </Row>

        <Form.Group controlId="explanationTextarea" className="rapport-form-group mb-4">
          <Form.Label>Explication / Justificatif de la dépense</Form.Label>
          <Form.Control
            onChange={(e) => setExplanation(e.target.value)}
            as="textarea"
            rows={3}
            value={explanation}
            className="rapport-textarea"
            placeholder="Détaillez ici la raison de cette charge..."
          />
        </Form.Group>

        <Form.Group controlId="formGridCheckbox" className="mb-4 d-flex align-items-center gap-2">
          <Form.Check
            type="checkbox"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            label="Je confirme l'exactitude des informations saisies"
            id="confirm-checkbox"
            style={{ fontWeight: '600', color: 'var(--text-main)' }}
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="rapport-button">
          Soumettre la Charge
        </Button>
      </Form>
        </Col>

        {user?.role === 'admin' && (
          <Col md={4}>
            <div className="admin-category-card" style={{ background: 'var(--card-bg, #ffffff)', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', marginTop: '20px' }}>
              <h4 style={{ marginBottom: '20px', color: 'var(--text-main)', borderBottom: '2px solid #3b82f6', paddingBottom: '8px' }}>
                {editingCategory ? "Modifier Type de Charge" : "Nouveau Type de Charge"}
              </h4>
              <Form onSubmit={handleCategorySubmit}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600' }}>Nom de la Charge</Form.Label>
                  <Form.Control
                    type="text"
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    placeholder="Ex: Nettoyage, Publicité..."
                    required
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600' }}>Affectation RBE</Form.Label>
                  <Form.Select
                    value={newCategoryRbe}
                    onChange={(e) => setNewCategoryRbe(e.target.value)}
                    required
                    style={{ borderRadius: '8px' }}
                  >
                    <option value="" disabled>Choisir la catégorie RBE...</option>
                    <option value="exploitation">Charges d'exploitation</option>
                    <option value="autresExploitation">Autres charges d'exploitation</option>
                    <option value="salariales">Charges salariales</option>
                    <option value="fiscales">Charges Fiscales</option>
                    <option value="bancaires">Charges Bancaires</option>
                    <option value="achatsConsommes">Achats consommés</option>
                  </Form.Select>
                </Form.Group>
                <div className="d-flex gap-2">
                  <Button variant={editingCategory ? "primary" : "success"} type="submit" style={{ flex: 1, borderRadius: '8px', padding: '10px', fontWeight: 'bold' }}>
                    {editingCategory ? "Enregistrer" : "Créer la catégorie"}
                  </Button>
                  {editingCategory && (
                    <Button variant="secondary" onClick={handleCancelEditCategory} style={{ borderRadius: '8px', padding: '10px', fontWeight: 'bold' }}>
                      Annuler
                    </Button>
                  )}
                </div>
              </Form>

              <h5 className="mt-4 mb-3" style={{ color: 'var(--text-main)', borderBottom: '2px solid #e2e8f0', paddingBottom: '6px' }}>Catégories existantes</h5>
              <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '8px', background: '#f8fafc' }}>
                {customCategories.length === 0 ? (
                  <p className="text-muted text-center my-2" style={{ fontSize: '14px' }}>Aucune catégorie personnalisée.</p>
                ) : (
                  customCategories.map((cat) => (
                    <div key={cat._id} className="d-flex justify-content-between align-items-center mb-2 p-2 bg-white rounded border" style={{ fontSize: '14px' }}>
                      <div style={{ flex: 1, minWidth: 0, paddingRight: '8px' }}>
                        <div style={{ fontWeight: 'bold', color: 'var(--text-main)', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={cat.name}>
                          {cat.name}
                        </div>
                        <small className="text-muted" style={{ fontSize: '11px' }}>
                          {cat.rbeCategory === 'exploitation' ? "Exploitation" :
                           cat.rbeCategory === 'autresExploitation' ? "Autres Expl." :
                           cat.rbeCategory === 'salariales' ? "Salariales" :
                           cat.rbeCategory === 'fiscales' ? "Fiscales" :
                           cat.rbeCategory === 'bancaires' ? "Bancaires" :
                           cat.rbeCategory === 'achatsConsommes' ? "Achats consommés" : cat.rbeCategory}
                        </small>
                      </div>
                      <div className="d-flex gap-1">
                        <Button variant="outline-primary" size="sm" style={{ padding: '2px 6px', fontSize: '11px' }} onClick={() => handleEditCategory(cat)}>
                          Modifier
                        </Button>
                        <Button variant="outline-danger" size="sm" style={{ padding: '2px 6px', fontSize: '11px' }} onClick={() => handleDeleteCategory(cat._id)}>
                          Supprimer
                        </Button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ChargeExp;
